import { ICardFieldProps } from "../cards/CardField"

/* Protopia Ecosystem component */
const CardFieldPrice = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    return <div 
        className={`landing-card-field landing-card-field-price ${value.className || ""}`} 
        style={value.style}
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >
        
    </div>
}
export default CardFieldPrice